import {Injectable} from '@angular/core';
import { environment } from 'environments/environment';
import {Capacitor} from '@capacitor/core';

@Injectable({providedIn: 'root'})
export class GoogleAnalyticsService {
  constructor() {
  }

  public addGATagToHead() {
    // TEMPORARY: skip GA4 on native mobile builds - same reasoning as the
    // GTM guard in google-tag-manager.ts (broken OneTrust banner on mobile).
    // Remove once OneTrust confirms a working mobile configuration.
    if (Capacitor.isNativePlatform()) {
      return;
    }

    const head = document.getElementsByTagName('head')[0];

    const gaScriptJs = document.createElement('script');
    gaScriptJs.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsTag}`;

    const dataLayerScript = document.createElement('script');
    dataLayerScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    window.gtag = function(){dataLayer.push(arguments);}
    window.gtag('js', new Date());

    var pathArray = window.location.pathname.split('/');
    pathArray.shift();
    var remainingPath = pathArray.slice(1).join('/');

    window.gtag('config', '${environment.googleAnalyticsTag}', {
      'custom_map': {'dimension1': 'path_after_first_slash'},
    });
    window.gtag('event', 'path_after_first_slash_dimension', {'path_after_first_slash': remainingPath});
  `;

    head.insertBefore(gaScriptJs, head.firstChild);
    gaScriptJs.after(dataLayerScript);
  }

  public addGeneralEventsAnalytics(type, name, data = null){
    // gtag is only defined once addGATagToHead() has run (skipped on native
    // mobile builds for now - see Capacitor.isNativePlatform() guard above).
    // Guard so callers across the app don't throw when it's absent.
    if (typeof (window as any).gtag !== 'function') {
      return;
    }
    if(data !== null){
      (window as any).gtag(type, name, data);
    } else{
      (window as any).gtag(type, name);
    }
  }
}
